import React from 'react';

import { Link } from 'react-router-dom';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import CarouselComponent from '../Components/CarouselComponent';
import glasphalt from '../Files/Glasphalt_gv.pdf';
import glasphaltGV from '../Images/sp_glasphalt_carbophalt_g.jpg';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme) => ({
  root: {
    fontFamily: 'Helvetica Neue, Helvetica, Arial,Verdana, sans-serif',
    color: '#4A4A4A',
    minHeight: '100vh',
    paddingTop: '2rem',
  },
  container: {
    justifyContent: 'center',
    padding: '2rem',
    margin: '5rem 0',
    textAlign: 'center',
    backgroundColor: 'rgb(208,225,232)',
  },
  description: {
    padding: ' 0 1rem ',
    [theme.breakpoints.down('xs')]: {
      textAlign: 'center',
    },
    [theme.breakpoints.up('md')]: {
      padding: '0 2rem',
      textAlign: 'left',
    },
  },
  carousel: {
    margin: '4rem',
    [theme.breakpoints.down('xs')]: {
      margin: '0rem',
    },
  },
  header: {
    marginBottom: '2rem ',
    fontSize: '2rem',
    [theme.breakpoints.down('xs')]: {
      fontSize: '2rem',
    },
  },
  textSettings: {
    padding: '2rem 0',
  },
  chapter: {
    [theme.breakpoints.down('xs')]: {
      fontSize: '1.1rem',
    },
  },
}));
const product = {
  title: 'S&P Glasphalt GV',
  subTitle: '120/120 kN/m (при удлинении 3%)',

  description:
    ' S&P Glasphalt GV – это сетка из стекловолокна для армирования слоев асфальтовых покрытий, предварительно покрытая слоем битума с односторонней посыпкой кварцевым песком и защитной полипропиленовой прокладкой из нетканого геоматериала с весом квадратного метра 20  г/м2 для предупреждения склеивания материала во время хранения и  транспортировки. Процесс пропитки формирующих сетку скруток, обеспечивает покрытие битумом не только наружной поверхности скруток, но и также поверхности стекловолокна, образующего скрутку. Такая пропитка обеспечивает взаимодействие всех волокон ипрепятствует скольжению волокон внутри скрутки.',

  imgText: 'main image description',
};

const Product = () => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Grid
        container
        style={{ justifyContent: 'center', marginBottom: '2rem' }}
      >
        <Typography
          component="h2"
          variant="h3"
          align="center"
          color="textPrimary"
          className={classes.header}
        >
          {product.title}
          {product.subTitle}
        </Typography>

        <Grid className={classes.description} item xs={12} sm={6}>
          <Typography variant="body1" color="inherit">
            {product.description}
          </Typography>
          <p>
            <Link
              style={{ color: 'black' }}
              to={glasphalt}
              target="_blank"
              download
            >
              S&P Glasphalt GV - описание
            </Link>
          </p>
        </Grid>
        <Grid item xs={12} sm={6}>
          <img style={{ width: '100%' }} src={glasphaltGV} alt="glasphaltGV" />
        </Grid>
      </Grid>
      {/* ///here */}
      <Grid container className={classes.container}>
        <div className={classes.textSettings}>
          <Typography className={classes.chapter} variant="h5" color="inherit">
            По техническим характеристикам при удлинении сеток не более 3%,
            разрывная нагрузка не менее 120 кН/м, как в продольном так и в
            поперечном направлении. Геосетка S&P Glasphalt GV в шесть раз дольше
            эксплуатируются в сравнении с полипропиленовыми и полиэфирными
            сетками.
          </Typography>
          <Typography className={classes.chapter} variant="h5" color="inherit">
            В сравнении, с предлагаемыми нами геосетками, геосетки из
            полипропилена и полиэфира имеют удлинение более 12 %, что 4-5 раз
            уменьшает, их заявленные характеристики сопротивления растяжения на
            разрыв.
          </Typography>
          <Typography className={classes.chapter} variant="h5" color="inherit">
            Геосетки S&P легко применять и укладывать, не анкеруются при
            укладке.
          </Typography>
          <Typography className={classes.chapter} variant="h5" color="inherit">
            Сертифицирована в РФ.
          </Typography>
        </div>
      </Grid>

      <div className={classes.carousel}>
        <CarouselComponent />
      </div>
    </div>
  );
};

export default Product;
